// =================================================================
// Engine: Audit hash — tamper-evident chain (PSD §4.2 / TODO Task 3.6)
// SHA-256 via Web Crypto API.
// =================================================================
/** Hashable content of an audit entry (all fields except the hash itself). */
function entryContent(entry) {
    return JSON.stringify({
        id: entry.id,
        timestampISO: entry.timestampISO,
        sessionId: entry.sessionId,
        eventType: entry.eventType,
        fieldChanged: entry.fieldChanged,
        oldValue: entry.oldValue,
        newValue: entry.newValue,
        engineVersion: entry.engineVersion,
    });
}
/** Compute SHA-256 of entry content chained with the prior hash. */
export async function computeAuditHash(entry, priorHash = '') {
    const data = entryContent(entry) + priorHash;
    const buf = new TextEncoder().encode(data);
    const digest = await crypto.subtle.digest('SHA-256', buf);
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
/** Verify a tamper-evident chain of audit entries. */
export async function verifyAuditChain(entries) {
    let priorHash = '';
    for (let i = 0; i < entries.length; i++) {
        const e = entries[i];
        const expected = await computeAuditHash(e, priorHash);
        if (expected !== e.hash) {
            return { valid: false, brokenAtIndex: i };
        }
        priorHash = e.hash;
    }
    return { valid: true, brokenAtIndex: -1 };
}
//# sourceMappingURL=auditHash.js.map